import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "./ErrorFallback";
import { logErrorToService } from "./errorLogger";

const AppErrorBoundary = ({ children, resetKeys }) => {
  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={(error, info) => {
        logErrorToService(error, info);
      }}
      onReset={() => {
        // Optional: clear local state, redux state, etc.
      }}
      resetKeys={resetKeys}
    >
      {children}
    </ErrorBoundary>
  );
};

export default AppErrorBoundary;
